import { ChartGanttIcon } from '@adsk/alloy-react-icon';

import { LegacyScheduleActivityCustomOptionLabel } from './components';
import { scheduleActivityPlugin } from '../activity';

/**
 * @deprecated
 * This plugin is officially deprecated and should not be used anymore. Instead, use both `scheduleActivityPlugin` and `planTaskPlugin`.
 */
export const legacyScheduleActivityPlugin = {
  ...scheduleActivityPlugin,
  renderIcon: ChartGanttIcon.renderIcon,
  CustomOptionLabel: LegacyScheduleActivityCustomOptionLabel,
  nestedOptions: undefined,
};
